import { Font } from "@react-pdf/renderer";
import { StyleSheet } from "@react-pdf/renderer";
import { PDF_EEG_EVALUATION_FONT_SIZE } from "../pdf/constants";
import { PDF_FOOTER_PAGE_PADDING_BOTTOM } from "../pdf/document-components/PdfFooter";

// Register fonts
Font.register({
    family: "Montserrat",
    fonts: [
        { src: "/fonts/Montserrat/static/Montserrat-Regular.ttf", fontWeight: "normal" },
        { src: "/fonts/Montserrat/static/Montserrat-Bold.ttf", fontWeight: "bold" },
    ],
});

export const styles = StyleSheet.create({
    page: {
        padding: 40,
        paddingBottom: PDF_FOOTER_PAGE_PADDING_BOTTOM,
        fontFamily: "Montserrat",
        textAlign: "justify",
    },
    titleContainer: {
        alignItems: "center",
        marginBottom: 50,
    },
    title: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.title,
        fontFamily: "Montserrat",
        fontWeight: "bold",
        textAlign: "center",
    },
    secondPageTitle: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.title,
        fontFamily: "Montserrat",
        fontWeight: "bold",
        textAlign: "left",
    },
    subtitle: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.subtitle,
        fontWeight: "bold",
        textAlign: "left",
        marginTop: 5,
    },
    tableContainer: {
        flexDirection: "column",
    },
    topSection: {
        marginBottom: 15,
    },
    otherFields: {
        marginTop: 10,
    },
    tableRow: {
        flexDirection: "row",
        marginBottom: 5,
    },
    tableLabel: {
        width: "40%",
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
        fontFamily: "Montserrat",
        fontWeight: "bold",
    },
    tableContent: {
        width: "60%",
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
    },
    column: {
        width: "48%",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    sectionTitle: {
        marginTop: 20,
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.subtitle,
        fontWeight: "bold",
        marginBottom: 5,
    },
    conectividadeSection: {
        marginTop: 10,
        marginBottom: 10,
    },
    sectionSubTitle: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.sectionSubtitle,
        fontWeight: 600,
        marginBottom: 3,
    },
    contentContainer: {
        marginBottom: 20,
    },
    text: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
        marginBottom: 5,
    },
    centeredText: {
        textAlign: "center",
    },
    brainImage: {
        alignSelf: "center",
    },
    contentWrapper: {
        flexGrow: 1,
        flexShrink: 1,
        display: "flex",
        flexDirection: "column",
    },
    noteSection: {
        marginTop: 20,
        marginBottom: 20,
    },
    noteText: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
    },
});
